<template>
  <div class="search-page common-bg">
    <van-nav-bar fixed title="搜索" left-arrow @click-left="$router.back()" class="search-nav-bar" />
    <div class="search-bar">
      <div class="search-category" @click="showCategory = !showCategory">
        <span>{{ currentCategory }}</span>
        <van-icon :name="showCategory ? 'arrow-up' : 'arrow-down'" color="#666666" />
      </div>
      <div class="search-input-wrap">
        <input type="text" v-model="keyword" placeholder="请输入游戏名称" @keyup.enter="handleSearch" />
        <van-icon v-if="keyword" name="clear" @click="clearKeyword" class="icon-clear" />
        <van-icon name="search" @click="handleSearch" class="icon-search" />
      </div>
    </div>
    <div class="category-dropdown" v-if="showCategory">
      <div v-for="cat in categories" :key="cat" :class="{ active: cat === currentCategory }" @click="selectCategory(cat)">
        {{ cat }}
      </div>
    </div>
    
    <div class="search-result">
      <!-- 历史记录（只要有内容就一直显示） -->
      <div class="history-section" v-if="historyList.length > 0">
        <div class="history-header">
          <span class="title">最近搜索</span>
          <span class="clear-all" @click="clearHistory">删除全部</span>
        </div>
        <div class="tags-wrap">
          <div class="tag-item" v-for="(item, index) in historyList" :key="index" @click="searchByHistory(item)">
            <span>{{ item }}</span>
            <van-icon name="cross" @click.stop="removeHistoryItem(index)" />
          </div>
        </div>
      </div>

      <!-- 搜索结果（已搜索才显示） -->
      <div class="result-section" v-if="hasSearched">
        <!-- 加载状态 -->
        <div class="loading-state" v-if="isLoading">
          <van-loading type="spinner" color="#DFB372" />
          <p>搜索中...</p>
        </div>

        <!-- 有结果 -->
        <div class="game-grid" v-else-if="searchResult.length > 0">
          <div class="game-card" v-for="(item, idx) in searchResult" :key="'res'+idx" @click="handleGameClick(item)">
            <img :src="item.mobile_img" @error="handleImageError($event)" />
            <img class="game-card-collect" :src="item.is_favorite ? '/static/newImg/index/game/btn_collect_ok.avif' : '/static/newImg/index/game/btn_collect_wait.avif'" @click.stop="toggleFavorite(item)" />
            <span class="game-card-name" v-if="!item.mobile_img_has_text"><img class="game-card-head" :src="item.api_logo_img" /> {{ item.game_name }}</span>
            <span class="game-card-label" v-if="item.tag && !item.mobile_img_has_text">{{ item.tag }}</span>
          </div>
        </div>

        <!-- 无结果 -->
        <div class="empty-state" v-else>
          <img src="/static/newImg/index/cion/empty.avif" alt="" class="empty-img" />
          <p>未找到相关游戏</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      keyword: '',
      currentCategory: '游戏',
      categories: ['游戏', '系统功能', '活动', '发现', '3399体育', '全部'],
      showCategory: false,
      searchResult: [],
      historyList: [],
      hasSearched: false,
      isLoading: false,
    }
  },
  created() {
    this.loadHistory();
  },
  methods: {
    selectCategory(cat) {
      this.currentCategory = cat;
      this.showCategory = false;
    },
    loadHistory() {
      const history = localStorage.getItem('app_game_search_history');
      this.historyList = history ? JSON.parse(history) : [];
    },
    saveHistory() {
      if (this.historyList.length > 0) {
        localStorage.setItem('app_game_search_history', JSON.stringify(this.historyList));
      } else {
        localStorage.removeItem('app_game_search_history');
      }
    },
    addToHistory(keyword) {
      if (!keyword) return;
      this.historyList = this.historyList.filter(item => item !== keyword);
      this.historyList.unshift(keyword);
      if (this.historyList.length > 10) {
        this.historyList = this.historyList.slice(0, 10);
      }
      this.saveHistory();
    },
    removeHistoryItem(index) {
      this.historyList.splice(index, 1);
      this.saveHistory();
    },
    clearHistory() {
      this.historyList = [];
      this.saveHistory();
    },
    clearKeyword() {
      this.keyword = '';
      this.searchResult = [];
      this.hasSearched = false;
    },
    searchByHistory(item) {
      this.keyword = item;
      this.handleSearch();
    },
    handleSearch() {
      const kw = this.keyword.trim();
      if (!kw) {
        this.$toast('请输入游戏名称');
        return;
      }
      this.isLoading = true;
      this.hasSearched = true;

      this.$apiFun.get('/api/game/search', { name: kw }).then(res => {
        if (res.code === 200) {
          this.searchResult = res.data || [];
          this.addToHistory(kw);
        } else {
          this.searchResult = [];
          this.$toast(res.msg || '搜索失败');
        }
        this.isLoading = false;
      }).catch(err => {
        this.searchResult = [];
        this.$toast('网络错误，请重试');
        this.isLoading = false;
      });
    },
    handleImageError(e) {
      e.target.onerror = null;
      e.target.src = '/static/newImg/index/game/default.avif';
    },
    toggleFavorite(item) {
      const that = this;
      const token = sessionStorage.getItem('token') || that.$store.state.token || '';
      if (!token) {
        that.$toast('请登录！');
        return;
      }
      that.$apiFun.post('/api/toggleFavorite', { game_id: item.id }).then(res => {
        if (res.code === 200) {
          item.is_favorite = res.data.is_favorite;
          that.$toast(item.is_favorite ? '已收藏' : '已取消收藏');
        } else {
          that.$toast(res.msg || '操作失败');
        }
      }).catch(() => {
        that.$toast('网络错误');
      });
    },
    handleGameClick(item) {
      const that = this;
      const token = sessionStorage.getItem('token') || that.$store.state.token || '';
      if (!token) {
        that.$toast('请登录！');
        return;
      }
      const code = String(item.game_code || '').trim();
      if (code === '0') {
        const cat2type = {
          realbet: 1, joker: 2, gaming: 3, lottery: 4, sport: 5, concise: 6, esports: 7, blockchain: 8,
        };
        const t = cat2type[item.category_id] || 3;
        that.$router.push({ name: 'gameList', query: { type: t } });
      } else {
        that.$parent.openGamePage(item.platform_name, item.game_code, '');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-page {
  min-height: 100vh;
  padding-top: 1.1rem;
  background: #1E1F24;
  color: #fff;
}
.search-bar {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.2rem;
  gap: 0.15rem;
  .search-category {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    padding: 0.15rem 0.2rem;
    background: #292A2C;
    border-radius: 0.1rem;
    font-size: 0.3rem;
    white-space: nowrap;
    color:#666666;
  }
  .search-input-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    background: #292A2C;
    border-radius: 0.1rem;
    padding: 0.1rem 0.2rem;
    input {
      flex: 1;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      font-size: 0.3rem;
      padding: 0.1rem 0;
      &::placeholder { color: #666; }
    }
    .icon-clear {
      font-size: 0.45rem;
      color: #999;
      margin-right: .35rem;
    }
    .icon-search {
      font-size: 0.45rem; /* 更大一点 */
      color: #DFB372; /* 金色 */
    }
  }
}
.category-dropdown {
  position: absolute;
  top: 2.2rem;
  left: 0.2rem;
  background: #292A2C;
  border-radius: 0.1rem;
  z-index: 100;
  min-width: 2rem;
  div {
    padding: 0.2rem 0.3rem;
    font-size: 0.3rem;
    color: #666666;
    &.active { color: #DFB372; }
    &:active { background: #3B3C3D; }
  }
}
.search-result {
  padding: 0 0.3rem;
  
  /* 历史记录 */
  .history-section {
    padding-top: 0.3rem;
    .history-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.3rem;
      .title {
        font-size: 0.32rem;
        font-weight: bold;
        color: #999;
      }
      .clear-all {
        font-size: 0.28rem;
        color: #F44336;
      }
    }
    .tags-wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 0.2rem;
      .tag-item {
        display: flex;
        align-items: center;
        gap: 0.1rem;
        padding: 0.15rem 0.25rem;
        background: #292A2C;
        border-radius: 0.15rem;
        font-size: 0.28rem;
        color: #999;
        .van-icon {
          font-size: 0.3rem;
          color: #666;
        }
      }
    }
  }

  /* 搜索结果 */
  .result-section {
    padding-top: 0.3rem;
    .loading-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 2rem 0;
      color: #999;
      font-size: 0.3rem;
      p { margin-top: 0.3rem; }
    }
    .game-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 0.15rem;
      .game-card {
        position: relative;
        border-radius: 0.1rem;
        overflow: hidden;
        cursor: pointer;
        img {
          width: 100%;
          display: block;
          border-radius: 0.35rem;
        }
        .game-card-label {
          position: absolute;
          top: 0.05rem;
          left: 0.05rem;
          background: rgba(223, 179, 114, 0.9);
          color: #000;
          font-size: 0.2rem;
          padding: 0.02rem 0.1rem;
          border-radius: 0.05rem;
        }
        .game-card-collect {
          position: absolute;
          top: 0.1rem;
          right: 0.1rem;
          width: 0.5rem;
          height: 0.5rem;
          cursor: pointer;
          background: #999;
        }
        .game-card-head {
          display: inline-block;
          width: 0.55rem;
          height: 0.5rem;
          vertical-align: middle;
          border-radius: 0;
          margin-right: 0.05rem;
        }
        .game-card-name {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          color: #f1f4fc;
          font-size: 0.28rem;
          font-weight: 600;
          text-shadow: 0 1px 3px rgba(0,0,0,0.8);
          white-space: nowrap;
        }
      }
    }
    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 3rem;
      .empty-img { 
        width: 2rem; 
        height: 2rem; 
        opacity: 0.5; 
      }
      p { 
        color: #666; 
        font-size: 0.3rem; 
        margin-top: 0.3rem; 
      }
    }
  }
}
</style>

<style lang="scss">
.search-nav-bar {
  background-color: #1e1f24 !important;
}
.search-nav-bar .van-nav-bar__title {
  color: #fff !important;
  font-size: 0.36rem !important;
}
.search-nav-bar .van-nav-bar .van-icon,
.search-nav-bar .van-nav-bar__arrow {
  color: #fff !important;
}
.search-nav-bar .van-hairline--bottom:after {
  border-bottom-width: 0 !important;
}
.search-bar .van-hairline--bottom:after {
  border-bottom-width: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue